<template>
  <v-row class="py-0">
    <v-col class="py-0">
      <v-btn-toggle
        v-if="format === 'buttons'"
        v-model="currentValue"
        color="primary"
        tile
        group
        mandatory
      >
        <v-btn
          v-for="(filter, index) in filters"
          :key="index"
          :value="filter.value"
          :disabled="filter.disabled"
        >
          <v-icon
            v-if="filter.icon"
            class="mr-2"
          >
            {{ filter.icon }}
          </v-icon>

          {{ filter.label }}
        </v-btn>
      </v-btn-toggle>

      <v-select
        v-else-if="format === 'select'"
        v-model="currentValue"
        :items="filters"
        :label="label"
        :clearable="clearable"
        style="min-width: 20em"
        item-text="label"
        item-value="value"
        item-disabled="disabled"
        hide-details
        solo
      >
        <template v-slot:item="{ item }">
          <v-list-item-action v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            {{ item.label }}
          </v-list-item-content>
        </template>
      </v-select>
    </v-col>

    <v-col class="py-0 align-self-center">
      <slot />
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    /** Table filters
     *    label: string
     *    icon: string
     *    value: string
     */
    filters: { type: Array, default: () => [] },

    // Selected filter value
    value: String,

    // Property field to apply filter to
    field: String,

    /** Format in which filters are displayed
     *    buttons   | Buttons group
     *    select    | Select input
     */
    format: {
      type: String,
      default: 'buttons',
      validator: value => ['buttons', 'select'].includes(value),
    },

    // Label for select format component
    label: String,

    clearable: Boolean,
  },

  data() {
    return {
      currentValue: '',
    };
  },

  watch: {
    value(newValue) {
      this.currentValue = newValue;
    },

    currentValue(newValue) {
      this.$emit('input', newValue);
    },
  },

  mounted() {
    this.currentValue = this.value;
  },
};
</script>
